<template>
  <!-- 拼团价格 -->
  <div class="group_buy_price">
    <img src="../../../../assets/img/productDetail/group_buy_new.png" alt="" v-if="nowAcvitity.fitUser === 2" class="group-buy-new">
    <img src="../../../../assets/img/productDetail/group_buy_old.png" alt="" v-if="nowAcvitity.fitUser === 3" class="group-buy-new">
    <div class="start_price">
      <div class="left_price">
        <div class="content-left">
          <div class="sale_price">
            <span>￥</span><b>{{calculationPrice(nowAcvitity.groupPrice).b }}</b>
            <span>{{calculationPrice(nowAcvitity.groupPrice).s }}</span>
          </div>
          <div class="origin-price">
            原价￥<b>{{calculationPrice(nowAcvitity.price).b }}</b>
            <span>{{calculationPrice(nowAcvitity.price).s }}</span>
          </div>
        </div>
        <div class="content-right">
          <div class="person-num-tag">
            {{numberTransform[nowAcvitity.groupNumber]}}人拼团价
          </div>
          <div class="sale-num">
            {{ courseBaseData.realSales + courseBaseData.initialSales }}人已拼
          </div>
        </div>

      </div>
      <div class="right_time">
        <div class="time2">
          <p>活动结束倒计时</p>
          <CommonTimer :endTime="endTime"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import moment from 'moment';
import {
  priceCount,
} from '@/utils/tools';
import CommonTimer from '@/components/commonComponents/CommonTimer.vue';

export default {
  components: { CommonTimer },
  data() {
    return {
      times: '', // 时间展示
      timeType: 0, // 1 大于3天 2小于3天
      timers: null, // 定时器
      numberTransform: {
        1: '一',
        2: '二',
        3: '三',
        4: '四',
        5: '五',
      },
      endTime: '',
    };
  },
  props: {
    nowAcvitity: {
      type: Object,
      default: () => ({}),
    },
    currentTime: {
      type: Number,
      default: 0,
    },
  },

  computed: {
    ...mapState(['courseBaseData']),
  },
  watch: {
    nowAcvitity: {
      handler() {
        this.checkTime();
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
  },
  mounted() {
  },
  destroyed() {
    clearInterval(this.timers);
  },
  methods: {
    // 价格小数位处理
    calculationPrice(price) {
      return priceCount(price);
    },
    checkTime() {
      this.endTime = moment(this.nowAcvitity.endTime).format('X');
    },
  },
};
</script>
<style scoped lang="scss">
// 直降
.group_buy_price {
  position: relative;
  width: 100%;
  height: 108px;

  .group-buy-new{
    position: absolute;
    top: -25px;
    left: 7px;
    width: 180px;
  }

  .start_price {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 108px;
    background: url('../../../../assets/img/productDetail/group_buy_bg.png') no-repeat;
    background-size: 100%;

    .left_price {
      display: flex;
      height: 108px;

      .sale_price {
        display: flex;
        align-items: flex-end;
        justify-content: flex-start;
        height: 46px;

        span {
          color: #fff;
          font-size: 29px;
        }

        b {
          color: #fff;
          font-size: 43px;
        }
      }

      .content-left {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding-left: 18px;

        .origin-price {
          margin-top: 8px;
          color: #fff;
          font-weight: 400;
          font-size: 22px;
          line-height: 31px;
          text-decoration: line-through;
        }
      }

      .content-right {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        margin-left: 36px;

        .price {
          color: #FFF;
          font-weight: 400;
          font-size: 22px;
          line-height: 31px;
          text-decoration: line-through;
        }

        .person-num-tag {
          display: flex;
          align-items: center;
          height: 36px;
          margin-top: 10px;
          padding: 0 18px;
          color: $theme_color;
          font-size: 24px;
          white-space: nowrap;
          background: #FBEEEA;
          border-radius: 18px 18px 18px 0;
        }
      }

      .sale-num {
        margin-top: 8px;
        color: #FFF;
        font-weight: 400;
        font-size: 22px;
        line-height: 31px;
      }
    }

    .right_time {
      padding-right: 21px;

      .time1 {
        color: #ff6c02;
        font-size: 22px;
        line-height: 28px;
        text-align: center;
      }

      .time2 {
        height: 108px;

        p {
          padding-top: 14px;
          color: #ff6c02;
          font-size: 22px;
          line-height: 31px;
          text-align: right;
        }

        div {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          padding-top: 14px;

          b.day {
            margin-right: 8px;

            &::after {
              top: 15px;
              right: -30px;
              font-size: 22px;
              content: '天';
            }
          }

          b {
            position: relative;
            display: inline-block;
            min-width: 32px;
            height: 32px;
            margin-left: 26px;
            color: #fff;
            font-weight: bold;
            font-size: 22px;
            line-height: 32px;
            text-align: center;
            background: #ff6c02;
            border-radius: 7px;

            &::after {
              position: absolute;
              top: 15px;
              right: -15px;
              display: inline-block;
              color: #ff6c02;
              font-weight: 500;
              font-size: 22px;
              transform: translateY(-50%);
              content: ':';
            }
          }

          b:last-child {
            &::after {
              display: none;
            }
          }
        }
      }
    }
  }
}
</style>
